import React, {  } from "react";
import { ItemValue, RendererFactory, Serializer } from "survey-core";
import { ReactQuestionFactory, SurveyQuestionRadiogroup } from "survey-react-ui";

import style from './_index.module.scss'

export class RadioGroupRowQuestion extends SurveyQuestionRadiogroup {

    constructor(props: any) {
        super(props);

        (this as any).renderItem = (
            item: ItemValue,
            value: any,
            cssClasses: any,
            index?: string
        ) => {
            const inputId = `input_${this.question.name}_${item.id}`;
            const optionType = this.question.getType() === "radiogroup" ? "radio" : "checkbox";

            let isChecked = this.question.isItemSelected(item);

            const handleOnChange = (event: any) => {
                this.question.clickItemHandler(item);
            }

            let itemClasses = [style.radio_box];

            if (this.question.buttonSize === "small") {
                itemClasses = [style.radio_box_small];

            } else if (this.question.buttonSize === "large") {
                itemClasses = [style.radio_box_large];
            }

            if (isChecked) {
                itemClasses.push(style.radio_box_active);
            }

            return (
                <div
                    role="presentation"
                    className={itemClasses.join(" ")}
                    onClick={(e) => {
                        const radio = document.getElementById(this.question.getItemId(item));
                        if (radio && e.target !== radio) {
                            radio.click();
                        }
                    }}
                    key={item.id}
                    id={inputId}
                >
                    <label htmlFor={inputId}>
                        {item.title}
                        <input
                            role="option"
                            id={this.question.getItemId(item)}
                            disabled={!this.question.getItemEnabled(item)}
                            name={this.question.name + item.id}
                            type={optionType}
                            value={item.value}
                            checked={isChecked}
                            onChange={handleOnChange}
                            onClick={(e) => e.stopPropagation()} // prevent event from bubbling up to the div
                        />
                    </label>
                </div>
            )
        }
    }

    getBody(cssClasses: any) {
        return (
            <div className={style.radio_group_row}>
                {this.getItems(cssClasses, this.question.bodyItems)}
            </div>
        )
    }

}

const clearButtonItem = Serializer.getProperty("radiogroup", "showClearButton");
const otherItem = Serializer.getProperty("radiogroup", "showOtherItem");
const noneItem = Serializer.getProperty("radiogroup", "showNoneItem");
const separateItems = Serializer.getProperty("radiogroup", "separateSpecialChoices");

const hideIfGroup = (obj: any) => {
    return obj.renderAs !== "radiobuttongroup";
}

const showIfGroup = (obj: any) => {
    return obj.renderAs !== "radiobuttongroup";
}

clearButtonItem.visibleIf = hideIfGroup;
otherItem.visibleIf = hideIfGroup;
noneItem.visibleIf = hideIfGroup;
separateItems.visibleIf = hideIfGroup;

Serializer.addProperty("radiogroup", {
    name: "buttonSize",
    displayName: "Button Size",
    category: "layout",
    visibleIndex: -1,
    visibleIf: showIfGroup,
    choices: [
        { value: "small", title: "Small" },
        { value: "medium", title: "Medium" },
        { value: "large", title: "Large" },
    ],
    default: "medium",
});

ReactQuestionFactory.Instance.registerQuestion(
    "sv-radio-button-group",
    (props) => {
        return React.createElement(RadioGroupRowQuestion, props);
    }
);

RendererFactory.Instance.registerRenderer(
    "radiogroup",
    "radiobuttongroup",
    "sv-radio-button-group"
);
